import { SkeletonLoading } from '@saleshandy/design-system';
import React from 'react';
import Table from '../../../../shared/design-system/components/organisms/table';
import { PaginationShowHide } from '../../../../shared/design-system/components/organisms/table/types';

const TestCreateUpdateFallback: React.FC = () => {
  const columns = [
    {
      dataField: 'senderName',
      text: 'Sender Name',
      cellClasses: 'test-email-account-sender-name',
      headerLoadingSkeleton: <SkeletonLoading width={84} height={14} />,
      cellLoadingSkeleton: (
        <div>
          <SkeletonLoading width={72} height={14} />
        </div>
      ),
    },
    {
      dataField: 'senderEmail',
      text: 'Sender Email',
      cellClasses: 'test-email-account-sender-email',
      headerLoadingSkeleton: <SkeletonLoading width={84} height={14} />,
      cellLoadingSkeleton: (
        <div className="d-flex align-items-center gap-4">
          <SkeletonLoading width={16} height={16} />
          <SkeletonLoading width={72} height={16} />
        </div>
      ),
    },
    {
      dataField: 'inboxPlacementTotalDailyLimit',
      text: 'Placement Test Daily Limit',
      cellClasses: 'test-email-account-placement-test-daily-limit',
      headerLoadingSkeleton: <SkeletonLoading width={100} height={14} />,
      cellLoadingSkeleton: (
        <div>
          <SkeletonLoading width={72} height={14} />
        </div>
      ),
    },
    {
      dataField: 'dailyLimit',
      text: 'Outreach Daily Limit',
      cellClasses: 'test-email-account-outreach-daily-limit',
      headerLoadingSkeleton: <SkeletonLoading width={100} height={14} />,
      cellLoadingSkeleton: (
        <div>
          <SkeletonLoading width={72} height={14} />
        </div>
      ),
    },
    {
      dataField: 'emailHealthScore',
      text: 'Account Health',
      cellClasses: 'test-email-account-account-health',
      headerLoadingSkeleton: <SkeletonLoading width={100} height={14} />,
      cellLoadingSkeleton: (
        <div>
          <SkeletonLoading width={72} height={14} />
        </div>
      ),
    },
    {
      dataField: 'owner',
      text: 'Owner',
      cellClasses: 'test-email-account-owner',
      headerLoadingSkeleton: <SkeletonLoading width={84} height={14} />,
      cellLoadingSkeleton: (
        <div>
          <SkeletonLoading width={24} height={24} borderRadius={100} />
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="d-flex flex-row justify-content-between align-items-center create-test-header">
        <div className="d-flex flex-row align-items-center gap-8">
          <SkeletonLoading width={300} height={24} />
          <SkeletonLoading width={146} height={24} borderRadius={100} />
        </div>
        <SkeletonLoading width={101} height={32} />
      </div>
      <div className="inbox-radar-create-test-container">
        <div className="d-flex gap-24 create-test-content-container">
          <div className="create-test-content__left-container">
            <div className="sequence-settings-sidebar">
              {Array.from({ length: 4 }).map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index} className="sequence-settings-sidebar__item">
                  <SkeletonLoading width={109} height={18} />
                </div>
              ))}
            </div>
          </div>
          <div className="create-test-content__right-container">
            <div className="create-test-content-wrapper">
              <div className="d-flex flex-column gap-16">
                <div className="card seed-esp-account" id="scheduling">
                  <div className="card-body">
                    <div className="d-flex flex-column justify-content-between gap-24">
                      <div className="d-flex flex-column title-subtitle">
                        <SkeletonLoading width={109} height={20} />
                        <SkeletonLoading width={337} height={18} />
                      </div>

                      <div className="esp-list">
                        <SkeletonLoading width={290} height={32} />
                        <SkeletonLoading width={290} height={32} />
                        <SkeletonLoading width={290} height={32} />
                        <SkeletonLoading width={290} height={32} />
                        <SkeletonLoading width={290} height={32} />
                        <SkeletonLoading width={290} height={32} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card" id="scheduling">
                  <div className="card-body">
                    <div className="d-flex flex-column justify-content-between gap-24">
                      <div className="d-flex flex-column title-subtitle">
                        <div className="d-flex flex-row align-items-center justify-content-between">
                          <SkeletonLoading width={109} height={20} />
                          <SkeletonLoading width={182} height={18} />
                        </div>
                        <SkeletonLoading width={337} height={18} />
                      </div>

                      <div className="email-setup-table">
                        <Table
                          data={[]}
                          columns={columns}
                          paginationOptions={{
                            options: {
                              totalElements: 0,
                              pageSize: 10,
                              pageNumber: 0,
                            },
                          }}
                          pagination={PaginationShowHide.HIDE}
                          isLoading={true}
                          loadingRowsCount={2}
                          tableWrapperClasses="inbox-test-email-account-table-wrapper"
                          bodyWrapperClasses="inbox-test-email-account-table-body"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestCreateUpdateFallback;
